/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungLayoutDto } from '../../models/aggregierte-auswertung-layout-dto';

export interface GetAggregierteAuswertungLayoutById$Json$Params {
  id: string;
}

export function getAggregierteAuswertungLayoutById$Json(http: HttpClient, rootUrl: string, params: GetAggregierteAuswertungLayoutById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, getAggregierteAuswertungLayoutById$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AggregierteAuswertungLayoutDto>;
    })
  );
}

getAggregierteAuswertungLayoutById$Json.PATH = '/v1/aggregierteAuswertung/layouts/{id}';
